export const getTimezoneDate = (date, timezone) => {
    if (!date) {
        return undefined;
    }
    const d = new Date(date);
    if (timezone) {
        const dateTimezoneOffset = getTimezoneOffset(timezone);
        const localTimezoneOffset = d.getTimezoneOffset();
        const difference = dateTimezoneOffset - localTimezoneOffset;
        return new Date(new Date(d.getTime() - difference * 60 * 1000).toISOString());
    }
    return d;
};
const getTimezoneOffset = (tz) => {
    const d = new Date();
    const a = d
        .toLocaleString('ja', { timeZone: tz })
        .split(/[/\s:]/)
        .map(Number);
    a[1]--;
    const t1 = Date.UTC(...a);
    const t2 = new Date(d).setMilliseconds(0);
    return (t2 - t1) / 60 / 1000;
};
//# sourceMappingURL=timezone.js.map